import React, { useEffect } from "react";
import Nlpbanner from "./Nlpbanner";
import Nlpabout from "./Nlpabout";
import Nlppower from "./Nlppower";
import Nlpfeat from "./Nlpfeat";
import Aimlbanners from "./Aimlbanners";
import Nlpsolution from "./Nlpsolution";

const Nlp = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
        <Nlpbanner/>
        <Nlpabout/>

        <Nlpsolution />
        <Nlppower/>
        <Nlpfeat/>
      {/* 
      

      <Poweraiml />
      <Aimlfeatures /> */}
    </div>
  );
};

export default Nlp;
